import { apolloClient } from 'apollo-client';
import { GET_ACCOUNT_NOTIFICATIONS } from 'hooks/use-account-notifications.hook';
import { trackError } from 'domain/tracking';
import { POLL_PAYMENT_METHODS } from './poll-for-payment-creation.api';

type PollForPaymentCreationResponse = {
  newPaymentMethod: PollPaymentMethodsQuery['account']['paymentMethods'][number];
};

export const pollForPaymentCreation = async (
  context: AddPaymentMethodContext
): Promise<PollForPaymentCreationResponse> => {
  const { accountId, existingPaymentMethodIds } = context;
  const observer = apolloClient.watchQuery<
    PollPaymentMethodsQuery,
    PollPaymentMethodsQueryVariables
  >({
    query: POLL_PAYMENT_METHODS,
    variables: { accountId: accountId || -1 },
    pollInterval: 1000,
  });
  let foundPaymentMethod;

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      observer.stopPolling();
      if (!foundPaymentMethod) {
        const error = new Error('Polling for payment method timed out');
        trackError({ error });
        return reject(error);
      }
    }, 20000);

    observer.subscribe({
      next: ({ data }) => {
        const newPaymentMethod = data.account.paymentMethods.find(
          method => !existingPaymentMethodIds?.includes(method.id)
        );
        if (newPaymentMethod) {
          observer.stopPolling();
          foundPaymentMethod = true;
          resolve({ newPaymentMethod });
          apolloClient.refetchQueries({
            include: [GET_ACCOUNT_NOTIFICATIONS],
          });
        }
      },
      error: e => reject(new Error(e)),
    });
  });
};
